import React, {
  Suspense,
  memo,
  useCallback,
  useEffect,
  useRef,
  useState,
} from "react";
import {
  Box,
  Grid,
  IconButton,
  MenuItem,
  Menu,
  ListItemIcon,
  Typography,
  Button,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Avatar,
  TextField,
  InputLabel,
  Tooltip,
} from "@mui/material";

import {
  FileDownloadOutlined as FileDownloadOutlinedIcon,
  AddCircle as AddCircleIcon,
  FilterAlt as FilterAltIcon,
  MoreHoriz as MoreHorizIcon,
  Visibility as VisibilityIcon,
  Delete as DeleteIcon,
  NoteAlt as NoteAltIcon,
  ArrowRight,
} from "@mui/icons-material";
import { useLocation, useNavigate } from "react-router-dom";
import {
  ClearCaseloadList,
  ClearReferralsList,
  ResetPagination,
  SetActiveTab,
  caseDocumentsById,
  changeTab,
  clearUnmountData,
  getCaseloadList,
  removeChat,
  setActiveDateFilter,
  setCaseloadCurentTab,
  setIsEndDate,
  setIsStartDate,
  setIsfilterObject,
  viewReferral,
} from "../../../redux/action";
import { useDispatch, useSelector } from "react-redux";
import { createSelector } from "reselect";
import CONSTANT from "../../../constants/constant";
import newRef from "../../../assets/Images/newRef.svg";
import CancelIcon from "@mui/icons-material/Cancel";
import activeRef from "../../../assets/Images/activeRef.svg";
import EditIcon from "@mui/icons-material/Edit";
import moment from "moment";
import Search from "../../../components/atoms/Search";
import css from "./index.module.scss";
import constant from "../../../constants/constant";
import { calculateAge, formatNHSNumber } from "../../../constants/utils";
import Modal from "../../../components/atoms/Modal";
import { CurrentUserData } from "../../../components/organism/overviewCaseload/interface";
import ConfirmationModal from "../../../components/atoms/ConfirmationModal";
import { useResponsive } from "../../../components/atoms/useResponsive";
import atoms from "../../../components/atoms";
import { useRejectedReferral } from "./RejectedRefferal";
import { useClearSearch } from "../../../components/atoms/Hooks/useClearSearch";
import AllDocuments from "./AllDocuments";
import { Message } from "@material-ui/icons";
import MovetoRefferal from "./MovetoRefferal";
import SystmOneActionChips from "./SystmOneActionChips";

const { DateRangePicker, Table } = atoms;
const Export = React.lazy(() => import("../../../components/atoms/Export"));

interface TabItemProps {
  activateTab: React.MutableRefObject<number>;
  index: number;
  title: string;
  iconSrc: string;
  onClickHandler: () => void;
  isActive: boolean;
}

interface Referral {
  ind: number;
  referral_id: string;
  patient_name: any;
  createdAt: string;
  updatedAt: string;
  submittedAt: string;
  age: number;
  patient_nhs_number: string;
  reject_reason?: string;
  notes?: string;
  status: string;
  action: string;
}

const Index = () => {
  const docListReducer = (state: any) => state?.caseDocumentReducer;
  let loginDetailString = localStorage.getItem("loginResponse");
  const referralReducer = (state: any) => state?.referralReducer;
  let loginDetail = loginDetailString ? JSON.parse(loginDetailString) : {};
  const location = useLocation();
  const Navigate = useNavigate();
  const dispatch = useDispatch();
  const pathParts = location.pathname.split("/").filter(Boolean);
  const [isActiveFilterVal, setActiveFilterVal] = useState<string>("");
  const param = pathParts[1];
  const activateTab = useRef(0);
  const [isViewRejectedRef, setisViewRejectedRef] = useState(false);
  const [isRedFlag, setIsRedFlag] = useState(false);
  const [CreatedAt, setCreatedAt] = useState("");
  const [isAllDocument, setisAllDocument] = useState(false);
  const { setSearch, search, clearSearch } = useClearSearch();
  const [limit, setLimit] = useState(10);
  const [isReason, setIsReason] = useState("");
  const [selectedId, setSelectedId] = useState<string | null>(null);
  const [page, setPage] = useState(1);
  const [clearStoredDateFiler, setClearStoredDateFiler] =
    useState<boolean>(false);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [sortType, setSortType] = useState("");
  const caseDocuments = createSelector(docListReducer, (state) => ({
    casedocList: state?.data?.data?.caseload_documents,
  }));

  const { casedocList } = useSelector(caseDocuments);

  const [anchorFilterEl, setAnchorFilterEl] =
    React.useState<null | HTMLElement>(null);
  const { windowWidth, isMediumScreen } = useResponsive();
  const open = Boolean(anchorFilterEl);
  const {
    handlerejectByID,
    formData,
    setFormData,
    selectedUserId,
    isRejectedRef,
    RefIDForPDF,
    anchorEl,
    setAnchorEl,
    setRefIDForPDF,
    setSelectedUserId,
    setisRejectedRef,
  } = useRejectedReferral({ activateTab });

  const handleFilterClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorFilterEl(event.currentTarget);
  };
  const handleFilterClose = () => {
    setAnchorFilterEl(null);
  };



  const caseloadReducer = (state: any) => state?.CaseloadReducer;
  const layoutReducer = (state: any) => state?.LayoutReducer;

  const columns = {
    columnAcceptRef: [
      {
        name: "#",
        cell: (row: any, index: number) => row.ind,
        width: "50px",
        tblName: "",
      },
      {
        name: "Message",
        cell: (item: any, ind: number) => (
          <span>
            {item.isUnreadMessage ? (
              <Message
                onClick={() => {
                  handleRowClick(item.id);
                  dispatch(setCaseloadCurentTab(5));
                }}
                fontSize="small"
                style={{ color: "#6A2382", cursor: "pointer" }}
              />
            ) : (
              "-"
            )}
          </span>
        ),
        sortable: false,
        width: "80px",
        tblName: "patient_dob",
      },

      {
        name: "Referral ID",
        cell: (item: any, ind: number) => (
          <span style={{ whiteSpace: "nowrap" }}>
            {item?.caseload_unique_id}
          </span>
        ),
        sortable: false,
        width: "150px",
        tblName: "caseload_unique_id",
      },
      {
        name: "Patient Name",
        cell: (item: any, ind: number) => (
          <Typography
            sx={{
              fontSize: "14px",
              display: "-webkit-box",
              textTransform: "capitalize",
              WebkitBoxOrient: "vertical",
              WebkitLineClamp: 2,
              overflow: "hidden",
              textOverflow: "ellipsis", // Optional: Adds ellipsis at the end of the truncated text
            }}
          >
            <Tooltip title={item?.patient_name}>{item.patient_name}</Tooltip>
          </Typography>
        ),
        selector: (item: any, ind: number) => item.patient_name,
        sortable: false,
        width: "150px",
        tblName: "patient_name",
      },
      {
        name: `Submitted Date ${
          sortType === "asc" ? " ▲" : sortType === "desc" ? " ▼" : ""
        }`,
        cell: (item: any, ind: number) => (
          <span>{moment(item.createdAt).format("DD/MM/YYYY")}</span>
        ),
        sortable: true,
        width: "150px",
        tblName: "createdAt",
      },
      {
        name: `Updated Date ${
          sortType === "asc" ? " ▲" : sortType === "desc" ? " ▼" : ""
        }`,
        cell: (item: any, ind: number) => (
          <span>{moment(item.updatedAt).format("DD/MM/YYYY")}</span>
        ),
        sortable: true,
        width: "150px",
        tblName: "updatedAt",
      },
     {
        name: "SystmOne Action",
        width: "220px",
        cell: (item: any) =>
          activateTab.current === 1 ? (
            <SystmOneActionChips
              item={item}
              param={param}
              page={page}
              limit={limit}
              isfilterObject={isfilterObject}
            />
          ) : null,
        sortable: false,
        tblName: "action",
      },

      {
        name: "Patient DOB",
        cell: (item: any, ind: number) => (
          <span>{moment(item.patient_dob).format("DD/MM/YYYY")}</span>
        ),
        sortable: false,
        width: "120px",
        tblName: "patient_dob",
      },
      {
        name: "NHS Number",
        cell: (item: any, ind: number) => (
          <span>{formatNHSNumber(item?.nhs_number)}</span>
        ),
        sortable: false,
        width: "120px",
        tblName: "nhs_number",
      },
      {
        name: "Pathway Status",
        cell: (item: any, ind: number) => (
          <span>{getStatusDescription(item, "pathway")}</span>
        ),
        sortable: false,
        width: "180px",
        tblName: "pathway_status",
      },
      {
        name: "Next Milestone",
        cell: (item: any, ind: number) => (
          <span>
            {param === "closed" ? "-" : getStatusDescription(item, "milestone")}
          </span>
        ),
        sortable: false,
        width: "180px",
        tblName: "milestone",
      },
      ...(param === "closed"
        ? [
            {
              name: "Outcome",
              cell: (item: any, ind: number) => (
                <>
                  {item?.clinical_review_accepted ? (
                    <span className="refReceived">Accepted</span>
                  ) : (
                    <span className="refClosed">Rejected</span>
                  )}
                </>
              ),
              sortable: false,
              width: "10%",
              tblName: "clinical_review_accepted",
            },
          ]
        : []),
      {
        name: "Source",
        width: "100px",
        cell: (item: any, ind: number) => (
          <span>
            {item?.referral?.submitted_by === CONSTANT.SCOPE.SCHOOL ? (
              <Typography className="activeStatus">Education</Typography>
            ) : item?.referral?.submitted_by === CONSTANT.SCOPE.CLIENT_ADMIN ? (
              <Typography className="deactiveStatus">Admin</Typography>
            ) : item?.referral?.submitted_by === CONSTANT.SCOPE.UNKNOWN ? (
              <Typography className="deactiveStatus">Open URL</Typography>
            ) : (
              <></>
            )}
          </span>
        ),
        sortable: false,
        tblName: "status",
      },

      {
        name: "Action",
        width: "80px",
        cell: (item: any, ind: number) => <span>{item.action}</span>,
        sortable: false,
        tblName: "action",
      },
    ],
    columnNewRef: [
      {
        name: "#",
        cell: (row: Referral, index: number) => row.ind,
        width: "50px",
        tblName: "",
      },
      {
        name: "Referral ID",
        cell: (item: Referral, ind: number) => (
          <span style={{ whiteSpace: "nowrap" }}>{item.referral_id}</span>
        ),
        sortable: false,
        width: "150px",
        tblName: "referral_id",
      },
      {
        name: "Patient Name",
        cell: (item: Referral, ind: number) => (
          <Typography
            sx={{
              fontSize: "14px",
              display: "-webkit-box",
              textTransform: "capitalize",
              WebkitBoxOrient: "vertical",
              WebkitLineClamp: 2,
              overflow: "hidden",
              textOverflow: "ellipsis", // Optional: Adds ellipsis at the end of the truncated text
            }}
          >
            <Tooltip title={item?.patient_name}>{item?.patient_name}</Tooltip>
          </Typography>
        ),
        selector: (item: any, ind: number) => item.patient_name,
        sortable: false,
        width: "150px",
        tblName: "patient_name",
      },
      {
        name: `Submitted Date ${
          sortType === "asc" ? " ▲" : sortType === "desc" ? " ▼" : ""
        }`,
        cell: (item: Referral, ind: number) => {
          const dateToFormat =
            param === "rejected" ? item.submittedAt : item.createdAt;
          return <span>{moment(dateToFormat).format("DD/MM/YYYY")}</span>;
        },
        sortable: true,
        width: "150px",
        tblName: "createdAt",
      },
      {
        name: `Updated Date ${
          sortType === "asc" ? " ▲" : sortType === "desc" ? " ▼" : ""
        }`,
        cell: (item: Referral, ind: number) => {
          return <span>{moment(item.updatedAt).format("DD/MM/YYYY")}</span>;
        },
        sortable: true,
        width: "150px",
        tblName: "updatedAt",
      },
      {
        name: "Patient Age",
        cell: (item: Referral, ind: number) => <span>{item.age}</span>,
        sortable: false,
        width: "100px",
        tblName: "age",
      },
      {
        name: "NHS Number",
        width: "120px",
        cell: (item: Referral, ind: number) => (
          <span>{formatNHSNumber(item?.patient_nhs_number)}</span>
        ),
        sortable: false,
        tblName: "patient_nhs_number",
      },

      ...(param === "rejected"
        ? [
            {
              name: "Rejected By",
              cell: (item: Referral) => <span>{item.reject_reason}</span>,
              sortable: false,
              width: "10%",
              tblName: "reject_reason",
            },
            {
              name: "Notes",
              cell: (item: Referral) => <span>{item.notes}</span>,
              sortable: false,
              width: "10%",
              tblName: "notes",
            },
          ]
        : []),

      {
        name: "Source",
        width: "100px",
        cell: (item: Referral, ind: number) => <span>{item?.status}</span>,
        sortable: false,
        tblName: "status",
      },
      {
        name: "Action",
        width: "80px",
        cell: (item: Referral, ind: number) => <span>{item?.action}</span>,
        sortable: false,
        tblName: "action",
      },
    ],
  };

  const userData: CurrentUserData = JSON.parse(
    localStorage.getItem("loginResponse") || "null"
  );

  const layoutURLData = createSelector(layoutReducer, (state) => ({
    currentTabRef: state.currentTabRef,
    caseloadIndex: state.caseloadIndex,
    isfilterObject: state.isfilterObject,
    stored_startDate: state.stored_startDate,
    stored_endDate: state.stored_endDate,
    activeDateFilter: state.activeDateFilter,
  }));
  const {
    currentTabRef,
    caseloadIndex,
    isfilterObject,
    stored_startDate,
    stored_endDate,
    activeDateFilter,
  } = useSelector(layoutURLData);

  const caseloadData = createSelector(caseloadReducer, (state) => ({
    caseloadList: state?.caseloadData,
  }));
  const { caseloadList } = useSelector(caseloadData);

  const referralData = createSelector(referralReducer, (state) => ({
    referralList: state?.referralList,
  }));
  const { referralList } = useSelector(referralData);

  const getStatusDescription = useCallback((item: any, type: string) => {
    const requiredStatuses = ["1", "2", "3"];
    const pathwayStatus = item?.pathway_status || [];
    const hasAllRequiredStatuses = requiredStatuses.every((status) =>
      pathwayStatus.includes(status)
    );

    if (hasAllRequiredStatuses && item?.pending_task > 0) {
      return type === "milestone" ? (
        <span className="clinicalReview">Ready Clinical Review</span>
      ) : (
        <span className="taskClr">Task</span>
      );
    }

    let compareType =
      type === "pathway"
        ? Math.max(...(item?.pathway_status || []))
        : type === "milestone"
        ? findGreatestNumber(item?.pathway_status, item) + 1
        : "";

    switch (compareType.toString()) {
      case CONSTANT.PATHWAY_STATUS.CASELOAD_CREATED:
        return <span className="refReceived">Referral Received</span>;
      case CONSTANT.PATHWAY_STATUS.CASELOAD_CLOSED:
        return <span className="refClosed">Referral Closed</span>;
      case CONSTANT.PATHWAY_STATUS.PARENT_REPORT_RECEIVED:
        return <span className="parentReport">Parent Report</span>;
      case CONSTANT.PATHWAY_STATUS.READY_FOR_MDT_REVIEW:
        return <span className="clinicalReview">Ready Clinical Review</span>;
      case CONSTANT.PATHWAY_STATUS.SCHOOL_REPORT_RECEIVED:
        return <span className="eduReport">Education Report</span>;
      default:
        return <span className="refClosed">Outcome Pending</span>;
    }
  }, []);

  const getFilteredDate = (
    activeDateFilter: string,
    caseloadIndex: string,
    storedDate: string,
    defaultDate: string
  ) => {
    return activeDateFilter === caseloadIndex && storedDate
      ? storedDate
      : defaultDate;
  };

  useEffect(() => {
    const handleActiveTab = () => {
      dispatch(changeTab(`Active Referrals`));
      if (activateTab.current === 1) {
        dispatch(
          getCaseloadList({
            page,
            search,
            limit,
            end_date: getFilteredDate(
              activeDateFilter,
              caseloadIndex,
              stored_endDate,
              endDate
            ),
            sortBy: sortType,
            start_date: getFilteredDate(
              activeDateFilter,
              caseloadIndex,
              stored_startDate,
              startDate
            ),
            status: constant.ACTIVE_REFERRAL_STATUS.ACCEPTED,
            filter: isfilterObject,
          })
        );
      }
      if (activateTab.current === 0) {
        dispatch(
          viewReferral({
            page,
            search,
            limit,
            end_date: getFilteredDate(
              activeDateFilter,
              caseloadIndex,
              stored_endDate,
              endDate
            ),
            start_date: getFilteredDate(
              activeDateFilter,
              caseloadIndex,
              stored_startDate,
              startDate
            ),
            sortBy: sortType,
          })
        );
      }
      if (activateTab.current === 2) {
        dispatch(
          viewReferral({
            page,
            search,
            limit,
            sortBy: sortType,
            end_date: getFilteredDate(
              activeDateFilter,
              caseloadIndex,
              stored_endDate,
              endDate
            ),
            start_date: getFilteredDate(
              activeDateFilter,
              caseloadIndex,
              stored_startDate,
              startDate
            ),
            status: constant.REFERRAL_STATUS.DRAFT,
          })
        );
      }
      if (loginDetail?.organization?.autoCaseloadCreation) {
        activateTab.current = 1;
      }
    };

    const handleClosedTab = () => {
      dispatch(changeTab(`Closed Referrals`));
      dispatch(
        getCaseloadList({
          page,
          search,
          limit,
          end_date: endDate,
          start_date: startDate,
          sortBy: sortType,
          status: constant.ACTIVE_REFERRAL_STATUS.CLOSED,
          filter: isfilterObject,
        })
      );
      activateTab.current = 1;
    };

    const handleRejectedTab = () => {
      dispatch(changeTab(`Rejected Referrals`));
      activateTab.current = 0;
      const status =
        param === "rejected" ? constant.REFERRAL_STATUS.REJECTED : null;
      dispatch(viewReferral({ page, search, limit, sortBy: sortType, status }));
    };

    if (param === "active") {
      handleActiveTab();
    } else if (param === "closed") {
      handleClosedTab();
    } else if (param === "rejected") {
      dispatch(SetActiveTab(0));
      handleRejectedTab();
    }

    return () => {
      dispatch(ClearCaseloadList());
      dispatch(ClearReferralsList());
    };
    // eslint-disable-next-line
  }, [
    param,
    page,
    search,
    limit,
    activateTab.current,
    endDate,
    sortType,
    clearStoredDateFiler,
  ]);

  const handleClick = (event: any, refId: string, id: string, pathway: any) => {
    setAnchorEl(event.currentTarget);
    setSelectedId(id);
    setRefIDForPDF(refId);
    dispatch(removeChat());
  };

  const handleRefClick = (
    event: any,
    id: string,
    caseloadId: string,
    rejectReason: any,
    createdAt: string,
    redflag: boolean
  ) => {
    setAnchorEl(event.currentTarget);
    setSelectedUserId(id);
    setSelectedId(caseloadId);
    setIsReason(rejectReason);
    setCreatedAt(createdAt);
    setIsRedFlag(redflag)
  };

  const handleClose = () => setAnchorEl(null);

  function findGreatestNumber(arr: any, fullData: any) {
    let numbersArr = arr
      ?.filter((num: any) => num !== null && num !== undefined)
      .map(Number);
    if (numbersArr && numbersArr?.length > 0) {
      let maxNumber = Math.max(...numbersArr);
      if (numbersArr?.includes(3) && !numbersArr?.includes(2)) {
        return 1;
      } else if (numbersArr?.includes(5)) {
        return 6;
      } else if (numbersArr?.includes(4) && !numbersArr?.includes(2)) {
        return 1;
      } else if (numbersArr?.includes(4) && !numbersArr?.includes(3)) {
        return 2;
      } else if (
        numbersArr?.includes(2) &&
        numbersArr?.includes(3) &&
        fullData?.pending_task === 0
      ) {
        return 4;
      } else {
        return maxNumber;
      }
    }
    return 0;
  }

  const handleRowClick = (id: any) =>
    Navigate(`/manage-caseload/create?id=${id}`);

  const handleNavigate = (type: string, mode: string) => {
    let url: string | null = null;
    setFormData({ date: "", time: "", reason: "" });

    if (mode === "newRef") {
      if (type === "view") {
        url = `/referral/view/${selectedUserId}`;
      } else if (type === "create-caseload") {
        url = `/referral/create-caseload/${selectedUserId}`;
      } else if (type === "update") {
        url = `/referral/update/${selectedUserId}`;
      } else if (type === "reject") {
        setisRejectedRef(true);
      } else if (type === "editRef") {
        url = `/referral/edit/${selectedUserId}`;
      }
    } else if (mode === "Accept") {
      if (type === "view") {
        if (param === "closed") {
          url = `/manage-caseload/create?type=${param}&id=${selectedId}`;
        } else {
          url = `/manage-caseload/create?id=${selectedId}`;
        }
      } else if (type === "update") {
        url = `/referral/update/${RefIDForPDF}`;
      } else if (type === "download") {
        setRefIDForPDF(RefIDForPDF);
      }
    }

    if (url) {
      Navigate(url);
    }
  };

  const handleAudit = (id: any) => Navigate(`/audit-trail/${id}`);

  useEffect(() => {
    if (userData?.scope === constant.SCOPE.CLINICIAN) {
      activateTab.current = 1;
    } else if (
      loginDetail?.organization?.autoCaseloadCreation &&
      param === "active"
    ) {
      activateTab.current = 1;
    } else if (param === "closed") {
      activateTab.current = 1;
    } else {
      activateTab.current = currentTabRef || caseloadIndex;
    }
    clearSearch();
    // eslint-disable-next-line
  }, [currentTabRef, param, caseloadIndex]);

  const handleSelectChange = (e: any) => {
    dispatch(ResetPagination(true));
    const selectedValues = e.target.value.toString();
    setActiveFilterVal(selectedValues);
    let filterVal = {
      pathway_status: selectedValues,
    };

    const filterValString = JSON.stringify(filterVal);
    dispatch(setIsfilterObject(filterValString));
    dispatch(
      getCaseloadList({
        page: 1,
        search,
        limit,
        status: constant.ACTIVE_REFERRAL_STATUS.ACCEPTED,
        filter: filterValString,
      })
    );
    handleFilterClose();
  };

  const filterEle = () => {
    return (
      <>
        {param !== "closed" && (
          <IconButton
            size="large"
            className="iconStyle removeHover"
            color="primary"
            sx={{
              border: `1px solid #6A2382`,
              "&:hover": {
                background: "none!important",
              },
            }}
            onClick={isfilterObject?.length > 0 ? undefined : handleFilterClick}
          >
            <FilterAltIcon fontSize="medium" />
            {isfilterObject?.length > 0 && (
              <CancelIcon
                fontSize="large"
                style={{
                  fontSize: "20px",
                  color: "red",
                  position: "absolute",
                  right: "-6px",
                  top: "-6px",
                  background: "#fff",
                }}
                onClick={() => {
                  dispatch(
                    getCaseloadList({
                      page,
                      search,
                      limit,
                      status: constant.ACTIVE_REFERRAL_STATUS.ACCEPTED,
                      filter: "",
                    })
                  );
                  handleFilterClose();
                  dispatch(setIsfilterObject({}));
                }}
              />
            )}
          </IconButton>
        )}
        <Menu
          id="basic-menu"
          anchorEl={anchorFilterEl}
          open={open}
          onClose={handleFilterClose}
          PaperProps={{
            elevation: 0,
            sx: {
              overflow: "visible",
              width: "350px",
              p: 0,
              filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
              mt: 1.5,
              "& .MuiAvatar-root": {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 1,
              },
              "&::before": {
                content: '""',
                display: "block",
                position: "absolute",
                top: 0,
                right: 14,
                width: 10,
                height: 10,
                bgcolor: "background.paper",
                transform: "translateY(-50%) rotate(45deg)",
                zIndex: 0,
              },
            },
          }}
          transformOrigin={{ horizontal: "right", vertical: "top" }}
          anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
        >
          {convertDataToOptions(constant)}
          <Button
            variant="outlined"
            onClick={() => {
              dispatch(
                getCaseloadList({
                  page,
                  search,
                  limit,
                  status: constant.ACTIVE_REFERRAL_STATUS.ACCEPTED,
                  filter: "",
                })
              );
              handleFilterClose();
              dispatch(setIsfilterObject({}));
            }}
            sx={{ borderRadius: "26px", margin: "0.5rem", float: "right" }}
          >
            <span> Clear All</span>
          </Button>
        </Menu>
      </>
    );
  };

  const convertDataToOptions = (data: any) => {
    const options = [];
    if (data?.PATHWAY_STATUS) {
      const statusMap = {
        CASELOAD_CREATED: "Referral Received",
        SCHOOL_REPORT_RECEIVED: "Education Report",
        PARENT_REPORT_RECEIVED: "Parent Report",
        TASK: "Task",
        READY_FOR_MDT_REVIEW: "Ready for Clinical Review",
      } as const;

      let index = 1;

      for (const key in data.PATHWAY_STATUS) {
        if (key === "CASELOAD_CLOSED" || key === "TASK") {
          continue;
        }

        options.push(
          <MenuItem
            key={key}
            value={data.PATHWAY_STATUS[key]}
            selected={Boolean(isActiveFilterVal === data?.PATHWAY_STATUS[key])}
            onClick={handleSelectChange}
          >
            {`${index}. ${statusMap[key as keyof typeof statusMap]}`}{" "}
          </MenuItem>
        );

        index++;
      }
    }
    return options;
  };

  const handleViewNotes = (data: string) => {
    setFormData((prevFormData) => ({ ...prevFormData, reason: data }));
    setisViewRejectedRef(true);
  };

  const handleAllDownload = (id: string | null, refID: string | null) => {
    dispatch(clearUnmountData());
    if (id) dispatch(caseDocumentsById(id, "navigate"));
    setisAllDocument(true);
  };

  const data =
    activateTab.current === 0
      ? referralList?.referrals?.map((item: any, index: number) => ({
          ...item,
          ind: ((page - 1) * limit + index + 1).toString().padStart(2, "0"),
          status:
            item.submitted_by === CONSTANT.SCOPE.SCHOOL ? (
              <Typography className="activeStatus">Education</Typography>
            ) : item.submitted_by === CONSTANT.SCOPE.CLIENT_ADMIN ? (
              <Typography className="deactiveStatus">Admin</Typography>
            ) : item.submitted_by === CONSTANT.SCOPE.UNKNOWN ? (
              <Typography className="deactiveStatus">Open URL</Typography>
            ) : (
              <></>
            ),
          reject_reason:
            item.reject_reason === null ? (
              <Typography className="activeStatus">System</Typography>
            ) : (
              <Typography className="deactiveStatus">Admin</Typography>
            ),
          notes:
            item.reject_reason === null ? (
              <Typography sx={{ textAlign: "center" }}> - </Typography>
            ) : (
              <Button
                className={css.btnStyle}
                size="small"
                variant="outlined"
                sx={{ borderRadius: "20px" }}
                onClick={() => handleViewNotes(item.reject_reason)}
              >
                View
              </Button>
            ),
          age: calculateAge(item.patient_dob),
          action: (
            <div key={index}>
              <IconButton
                aria-controls={`item-menu-${item?.id}`}
                aria-haspopup="true"
                className="iconStyleAction"
                onClick={(e) =>
                  handleRefClick(
                    e,
                    item?.id,
                    item.caseload_id,
                    item.reject_reason,
                    item.submittedAt,
                    item.isRedFlag
                  )
                }
                color="primary"
                sx={{ border: `1px solid #6A2382` }}
              >
                <MoreHorizIcon fontSize="medium" />
              </IconButton>

              <Menu
                id={`item-menu-${item?.id}`}
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleClose}
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "left",
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
              >
                <MenuItem
                  onClick={() =>
                    handleNavigate("view", selectedId ? "Accept" : "newRef")
                  }
                >
                  <ListItemIcon>
                    <VisibilityIcon />
                  </ListItemIcon>
                  View
                </MenuItem>

                {param !== "closed" && param !== "rejected" && (
                  <MenuItem onClick={() => handleNavigate("update", "newRef")}>
                    <ListItemIcon>
                      <EditIcon />
                    </ListItemIcon>
                    Edit
                  </MenuItem>
                )}

                {param === "rejected" && isReason && (
                  <MovetoRefferal
                    CreatedAt={CreatedAt}
                    selectedId={selectedId}
                    selectedUserId={selectedUserId}
                    type={(isRedFlag && !selectedId) ? "RED_FLAG" : "REJECTED"}
                    // type={"REJECTED"}
                    setAnchorEl={setAnchorEl}
                  />
                )}

                {param !== "closed" && param !== "rejected" && (
                  <MenuItem
                    onClick={() => handleNavigate("create-caseload", "newRef")}
                  >
                    <ListItemIcon>
                      <AddCircleIcon />
                    </ListItemIcon>
                    Accept Referral
                  </MenuItem>
                )}

                <MenuItem onClick={() => handleAllDownload(selectedId, "")}>
                  <ListItemIcon>
                    <FileDownloadOutlinedIcon />
                  </ListItemIcon>
                  Download
                </MenuItem>

                {param !== "closed" && param !== "rejected" && (
                  <MenuItem onClick={() => handleNavigate("reject", "newRef")}>
                    <ListItemIcon>
                      <DeleteIcon />
                    </ListItemIcon>
                    Reject
                  </MenuItem>
                )}
              </Menu>
            </div>
          ),
        }))
      : activateTab.current === 1
      ? caseloadList?.ActiveReferrals?.map((item: any, index: number) => ({
          ...item,
          ind: ((page - 1) * limit + index + 1).toString().padStart(2, "0"),
          caseload_unique_id: (
            <div
              onClick={() => handleRowClick(item.id)}
              style={{ cursor: "pointer" }}
            >
              {item.caseload_unique_id}
            </div>
          ),
          status:
            item.status === CONSTANT.STATUS.ACTIVE ? (
              <Typography className="activeStatus">Active</Typography>
            ) : (
              <Typography className="deactiveStatus">Deactive</Typography>
            ),
          action: (
            <div key={index}>
              <IconButton
                size="large"
                className="iconStyleAction"
                color="primary"
                aria-controls={`item-menu-${item?.id}`}
                aria-haspopup="true"
                onClick={(e) => {
                  handleClick(
                    e,
                    item?.referral_id,
                    item?.id,
                    item?.pathway_status.includes("2") ||
                      item?.pathway_status.includes("3")
                  );
                }}
                sx={{ border: `1px solid #6A2382` }}
              >
                <MoreHorizIcon fontSize="medium" />
              </IconButton>

              <Menu
                id={`item-menu-${item?.id}`}
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleClose}
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "left",
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
              >
                <MenuItem onClick={() => handleNavigate("view", "Accept")}>
                  <ListItemIcon>
                    <VisibilityIcon />
                  </ListItemIcon>
                  View
                </MenuItem>

                {param !== "closed" && (
                  <MenuItem onClick={() => handleNavigate("update", "Accept")}>
                    <ListItemIcon>
                      <EditIcon />
                    </ListItemIcon>
                    Edit
                  </MenuItem>
                )}

                <MenuItem onClick={() => handleAudit(RefIDForPDF)}>
                  <ListItemIcon>
                    <NoteAltIcon />
                  </ListItemIcon>
                  Audit Trail
                </MenuItem>

                {/* {param !== "closed" && param !== "rejected" && ( <MenuItem onClick={() => handleDownload(null, selectedId)}>
                  <ListItemIcon>
                    <FileDownloadOutlinedIcon />
                  </ListItemIcon>
                  Download
                </MenuItem> )} */}

                {
                  // param !== "closed" &&
                  param !== "rejected" && (
                    <MenuItem onClick={() => handleAllDownload(selectedId, "")}>
                      <ListItemIcon>
                        <FileDownloadOutlinedIcon />
                      </ListItemIcon>
                      Download
                    </MenuItem>
                  )
                }

                {param !== "closed" && param !== "rejected" && (
                  <MenuItem onClick={() => handleNavigate("reject", "newRef")}>
                    <ListItemIcon>
                      <DeleteIcon />
                    </ListItemIcon>
                    Reject
                  </MenuItem>
                )}
              </Menu>
            </div>
          ),
        }))
      : activateTab.current === 2
      ? referralList?.referrals?.map((item: any, index: number) => ({
          ...item,
          ind: ((page - 1) * limit + index + 1).toString().padStart(2, "0"),
          status:
            item.submitted_by === CONSTANT.SCOPE.SCHOOL ? (
              <Typography className="activeStatus">Education</Typography>
            ) : item.submitted_by === CONSTANT.SCOPE.CLIENT_ADMIN ? (
              <Typography className="deactiveStatus">Admin</Typography>
            ) : item.submitted_by === CONSTANT.SCOPE.UNKNOWN ? (
              <Typography className="deactiveStatus">Open URL</Typography>
            ) : (
              <></>
            ),
          age: calculateAge(item.patient_dob),
          action: (
            <div key={index}>
              <IconButton
                aria-controls={`item-menu-${item?.id}`}
                aria-haspopup="true"
                className="iconStyleAction"
                onClick={(e) =>
                  handleRefClick(e, item?.id, item.caseload_id, "", "", false)
                }
                color="primary"
                sx={{ border: `1px solid #6A2382` }}
              >
                <MoreHorizIcon fontSize="medium" />
              </IconButton>

              <Menu
                id={`item-menu-${item?.id}`}
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleClose}
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "left",
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
              >
                {activateTab.current !== 2 && (
                  <MenuItem onClick={() => handleNavigate("view", "newRef")}>
                    <ListItemIcon>
                      <VisibilityIcon />
                    </ListItemIcon>
                    View
                  </MenuItem>
                )}
                {activateTab.current === 2 && (
                  <MenuItem onClick={() => handleNavigate("editRef", "newRef")}>
                    Continue
                    <ListItemIcon>
                      <ArrowRight />
                    </ListItemIcon>
                  </MenuItem>
                )}

                {param !== "closed" &&
                  param !== "rejected" &&
                  activateTab.current === 0 && (
                    <MenuItem
                      onClick={() =>
                        handleNavigate("create-caseload", "newRef")
                      }
                    >
                      <ListItemIcon>
                        <AddCircleIcon />
                      </ListItemIcon>
                      Accept Referral
                    </MenuItem>
                  )}

                {param !== "closed" &&
                  param !== "rejected" &&
                  activateTab.current === 0 && (
                    <MenuItem
                      onClick={() => handleNavigate("reject", "newRef")}
                    >
                      <ListItemIcon>
                        <DeleteIcon />
                      </ListItemIcon>
                      Reject
                    </MenuItem>
                  )}
              </Menu>
            </div>
          ),
        }))
      : null;

  const handleOnchange = (e: any) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };


  const tableWidth = () => {
    const sidebarWidth = !isMediumScreen ? 0 : 270;
    const adjustedWidth = windowWidth - sidebarWidth;
    return `calc(${adjustedWidth}px)`;
  };

  const handleSort = (
    column: { tblName: string },
    sortDirection: "asc" | "desc"
  ) => {
    const { tblName } = column;
    if (tblName === "createdAt") {
      setSortType(sortDirection);
    }
  };

  const TabItem: React.FC<TabItemProps> = ({
    activateTab,
    index,
    title,
    iconSrc,
    onClickHandler,
    isActive,
  }) => (
    <ListItem
      disablePadding
      sx={{
        borderRadius: {
          lg: index === 0 ? "2rem 0 0 2rem" : "0 2rem 2rem 0",
          md: index === 0 ? "2rem 0 0 2rem" : "0 2rem 2rem 0",
          sm: index === 0 ? "2rem 0 0 2rem" : "0 2rem 2rem 0",
          xs: "2rem",
          "&:hover": {
            ".MuiListItemButton-root": {
              background: "transparent",
            },
          },
        },
      }}
      onClick={onClickHandler}
      className={isActive ? "nav-active" : "nav-Pagelink"}
    >
      <ListItemButton>
        <ListItemIcon>
          <Avatar
            src={iconSrc}
            alt={title}
            sx={{
              width: {
                xl: 24,
                lg: 20,
                md: 20,
                xs: 25,
              },
              height: {
                xl: 24,
                lg: 20,
                md: 20,
                xs: 25,
              },
              borderRadius: "0%",
              margin: "auto",
            }}
          />
        </ListItemIcon>
        <ListItemText primary={title} sx={{ whiteSpace: "nowrap" }} />
      </ListItemButton>
    </ListItem>
  );

  const handleTabClick = (index: number, title: string) => {
    activateTab.current = index;
    setPage(1);
    setLimit(10);
    dispatch(changeTab(title));
    dispatch(SetActiveTab(index));
    dispatch(ResetPagination(true));
    setSortType("");
    setStartDate("");
    setEndDate("");
  };

 
  return (
    <>
      <Box className="innerheader">
        <Grid
          container
          direction="row"
          justifyContent="space-between"
          className="forMobilecss"
        >
          <Grid item xs={6} className="searchInputbx">
            <Search
              searchCallBack={(e: string) => setSearch(e)}
              searchValue={search}
            />
          </Grid>
          <Grid
            item
            xs={6}
            display={"flex"}
            gap={2}
            justifyContent={"end"}
            className="filterOption"
          >
            {activateTab.current === 1 && param !== "closed" && filterEle()}
            <Suspense fallback={<div>Loading...</div>}>
              <Export
                data={
                  activateTab.current === 0
                    ? referralList?.referrals
                    : activateTab.current === 1
                    ? caseloadList?.ActiveReferrals
                    : null
                }
                columns={
                  activateTab.current === 0
                    ? columns["columnNewRef"]
                    : activateTab.current === 1
                    ? columns["columnAcceptRef"]
                    : null
                }
              ></Export>
            </Suspense>
            {param === "active" &&
            userData?.scope !== constant.SCOPE.CLINICIAN ? (
              <Button
                className={css.btnStyle}
                onClick={() => {
                  Navigate("/referral/add");
                  dispatch(setIsfilterObject({}));
                  dispatch(
                    SetActiveTab(
                      !loginDetail?.organization?.autoCaseloadCreation ? 0 : 1
                    )
                  );
                  dispatch(setActiveDateFilter(null));
                  dispatch(setIsEndDate(null));
                  dispatch(setIsStartDate(null));
                }}
                size="large"
                variant="contained"
                sx={{ borderRadius: "30px" }}
                startIcon={<AddCircleIcon />}
              >
                Add new Referral
              </Button>
            ) : null}
          </Grid>
        </Grid>
        <Grid
          container
          justifyContent={"space-between"}
          alignItems={"center"}
          my={2}
        >
          {param === "active" &&
            !loginDetail?.organization?.autoCaseloadCreation &&
            userData?.scope !== constant.SCOPE.CLINICIAN && (
              <Grid
                item
                lg={4}
                sm={6}
                md={6}
                xs={12}
                mb={{
                  xs: "1rem",
                  lg: "0",
                  md: "0",
                  sm: "0",
                }}
              >
                <List
                  component="div"
                  disablePadding
                  sx={{
                    display: "flex",
                    flexDirection: {
                      xs: "column",
                      lg: "row",
                      md: "row",
                      sm: "row",
                    },
                    gap: {
                      xs: "1rem",
                      lg: "0",
                      md: "0",
                      sm: "0",
                    },
                  }}
                >
                  <TabItem
                    activateTab={activateTab}
                    index={0}
                    title="New Referrals"
                    iconSrc={newRef}
                    onClickHandler={() => handleTabClick(0, "New Referrals")}
                    isActive={activateTab.current === 0}
                  />
                  <TabItem
                    activateTab={activateTab}
                    index={1}
                    title="Active Referrals"
                    iconSrc={activeRef}
                    onClickHandler={() => handleTabClick(1, "Active Referrals")}
                    isActive={activateTab.current === 1}
                  />
                </List>
              </Grid>
            )}

          {param === "active" && (
            <Grid
              display={"flex"}
              justifyContent={"end"}
              alignItems={"center"}
              lg={4}
              sm={6}
              md={6}
              xs={12}
              ml={"auto"}
            >
              {(activeDateFilter === caseloadIndex
                ? stored_endDate
                : endDate) && (
                <Button
                  onClick={() => {
                    setStartDate("");
                    setEndDate("");
                    setClearStoredDateFiler(true);
                    dispatch(setActiveDateFilter(null));
                    dispatch(setIsEndDate(null));
                    dispatch(setIsStartDate(null));
                  }}
                  sx={{
                    textDecoration: "underline",
                    color: "#6A2382",
                    marginRight: "1rem",
                    whiteSpace: "nowrap",
                  }}
                >
                  Reset Filter
                </Button>
              )}

              <DateRangePicker
                handleEndDate={(date) => {
                  dispatch(ResetPagination(true));
                  dispatch(setIsEndDate(date));
                  dispatch(setActiveDateFilter(caseloadIndex));
                  setEndDate(date);
                }}
                handleStartDate={(date) => {
                  setStartDate(date);
                  dispatch(setIsStartDate(date));
                }}
                startDateValue={
                  activeDateFilter === caseloadIndex
                    ? stored_startDate
                    : startDate
                }
                endDateValue={
                  activeDateFilter === caseloadIndex ? stored_endDate : endDate
                }
                endMinDate={
                  activeDateFilter === caseloadIndex
                    ? stored_startDate
                    : startDate
                }
              />
            </Grid>
          )}
        </Grid>
      </Box>
      <Grid
        className="tableWrapper"
        style={{ maxWidth: tableWidth() }}
        sx={{
          'div[role="columnheader"]': {
            span: {
              display: "none",
            },
          },
        }}
      >
        <Table
          handleSort={handleSort}
          className={"userLisingTable"}
          columns={
            activateTab.current === 0
              ? columns["columnNewRef"]
              : activateTab.current === 1
              ? columns["columnAcceptRef"]
              : activateTab.current === 2
              ? columns["columnNewRef"]
              : {}
          }
          data={data}
          setLimitPerPage={(e: number) => setLimit(e)}
          limit={limit}
          paginationTotalRows={
            activateTab.current === 0
              ? referralList?.totalPages
              : caseloadList?.totalPages
          }
          pagination={true}
          setCurrentPage={(e: number) => setPage(e)}
        />
      </Grid>

      <ConfirmationModal
        open={isRejectedRef || isViewRejectedRef}
        handleClose={
          isViewRejectedRef
            ? () => setisViewRejectedRef(false)
            : () => setisRejectedRef(false)
        }
        title="Reject Referral"
        message={
          <Grid item sx={{ width: "100%" }}>
            <InputLabel
              htmlFor="outlined-adornment-password"
              sx={{
                textAlign: "left",
                fontFamily: "poppins",
                marginBottom: "0.5rem",
              }}
            >
              Reason
            </InputLabel>
            <TextField
              multiline
              sx={{ marginBottom: "0.5rem", width: "100%" }}
              placeholder="Write a Reason..."
              rows={4}
              defaultValue={formData.reason}
              disabled={isViewRejectedRef ? true : false}
              name="reason"
              variant="outlined"
              onChange={handleOnchange}
            ></TextField>
          </Grid>
        }
        onConfirm={isViewRejectedRef ? undefined : () => handlerejectByID()}
        confirmLabel={isViewRejectedRef || !formData.reason ? "" : "Reject"}
        cancelLabel={"Cancel"}
        onCancel={
          isViewRejectedRef
            ? () => setisViewRejectedRef(false)
            : () => setisRejectedRef(false)
        }
      />

 

      <Modal
        open={isAllDocument}
        handleClose={() => {
          setisAllDocument(false);
        }}
        title={"Documents"}
        sx={{
          ".MuiDialog-container": {
            ".MuiDialog-paper": {
              minWidth: "60%!important",
            },
          },
        }}
      >
        <Box className={css.clinicModal}>
          <AllDocuments
            casedocList={casedocList}
            caseloadId={selectedId}
            refId={selectedUserId}
          />
        </Box>
      </Modal>
    </>
  );
};

export default memo(Index);
